const SentNotification = () =>
  import(
    /* webpackChunkName: "message-sent-notification" */ '@/pages/message/sent/notification/index.vue'
  )

export default {
  path: 'notification',
  meta: {
    label: 'notification',
    auth: 'notification'
  },
  component: {
    name: 'Notification',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'MessageSentNotification',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: SentNotification
    }
  ]
}
